import { Send } from '@mui/icons-material';
import { Avatar, Box, Card, CardContent, Divider, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { Component } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Message, User } from './Types/Types';

interface Props {
    user: User | null,
};
class Chatroom extends Component<Props, { messages: Message[] }> {
    messageRef : React.RefObject<HTMLInputElement>;
    constructor(props : Props) {
        super(props);
    
        const chatroomStr = localStorage.getItem('chatroom');
        this.state={
            messages: JSON.parse(chatroomStr ?? '[]'),
        };
        this.messageRef = React.createRef();
    }
    

    componentDidMount() {
        this.handleGetMessages();
    }

    handleUpdateMessageCount = (messages : Message[], total: number) => {
        localStorage.setItem('chatroom', JSON.stringify(messages));

        localStorage.setItem('message-count', JSON.stringify(total));
        localStorage.setItem('message-count-seen', JSON.stringify(total));

        this.setState({
            messages: messages,
        }, () => {
            document.dispatchEvent(new CustomEvent('update-messages'));
        });
    }

    handleGetMessages = () => {
        axios.get<{messages: Message[], total:number}>('/messages')
            .then(res => {
                const data = res.data;
                const messages = data.messages;
                const total = data.total;
                
                this.handleUpdateMessageCount(messages, total);
            });
    }

    handleSendMessage = () => {
        if (this.messageRef && this.messageRef.current) {
            const message = this.messageRef.current.value;
            if (message.length > 0) {
                axios.post<{messages: Message[], total:number}>('/messages', {
                    message: message,
                }).then(res => {
                    this.messageRef.current!.value = '';

                    const data = res.data;
                    const messages = data.messages;
                    const total = data.total;
                    
                    this.handleUpdateMessageCount(messages, total);
                    setTimeout(() => {
                        this.messageRef.current!.scrollTo({ top: this.messageRef.current!.scrollHeight });
                    });
                });
            }
        }
    }

    render() {
        const { user } = this.props;
        const { messages } = this.state;


        const getAvatar = (image : null | string) => {
            if (image) {
                if (image.startsWith('hoff')) {
                    return process.env.PUBLIC_URL + '/img/' + image;
                }
                return process.env.PUBLIC_URL + '/awards/' + image;
            }
            return undefined;
        }

        return (
            <React.Fragment>
                <Box>
                    <Typography textAlign={'center'} variant={'h5'} sx={{ p: 2, pb: 0 }}>Rauchzeichen</Typography>
                    <Typography textAlign={'center'} variant={'body1'} sx={{ pb: 2 }}>Bleib in Kontakt mit de Buam.</Typography>
                </Box>
                <Divider />
                <Box flexGrow={1} sx={{ marginTop: 2, overflowY: 'auto', paddingRight: 1, paddingLeft: 1 }}>
                    {messages.length > 0
                        ? <Virtuoso followOutput={true} data={messages} itemContent={(index : number, message : Message) => {
                            const isMe = message.user_id === user?.id;
                            const sameUser = index > 0 && message.user_id === messages[index-1].user_id;

                            return <Box key={'msg-'+message.id} sx={{ display: 'flex', width: '100%', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
                                <Box flexGrow={0} sx={{ marginBottom: 1, flexBasis: '80%' }}>
                                    <Box sx={{ display: 'flex', flexDirection: isMe ? 'row-reverse' : 'row' }}>
                                        <Box sx={{ minWidth: '40px' }}>
                                            {sameUser === false && <Avatar src={getAvatar(message.user_image)}/>}
                                        </Box>
                                        <Card sx={{ marginLeft: 2, marginRight: 2, background: isMe ? '#313131' : '#232323', border: '1px solid rgba(255, 215, 0, 0.1)' }}>
                                            <CardContent sx={{ padding: '4px !important', paddingLeft: '8px !important', paddingRight: '8px !important', lineHeight: '1.25em' }}>
                                                <Box>
                                                    {sameUser === false && <Box sx={{ fontWeight: 'bold', fontSize: '0.65em', lineHeight: '1.1em', textAlign: isMe ? 'right' : 'left' }}>{message.user_name}</Box>}
                                                    <Box>{message.text}</Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </Box>
                            </Box>;    
                        }}/>
                        : <Box sx={{ display: 'grid', placeItems: 'center', height: '100%', width: '100%', textAlign: 'center' }}>
                            <Box>
                                <Box>No nix do!</Box>
                                <Box>Amend dafrogst spada wos.</Box>
                            </Box>
                        </Box>}
                </Box>
                <Box sx={{ padding: '4px' }}>
                    <form onSubmit={(e) => this.handleSendMessage()}>
                        <TextField 
                            inputRef={this.messageRef}
                            fullWidth 
                            multiline
                            placeholder='Dazöh wo gehts heid no hi?'
                            onSubmit={(e) => this.handleSendMessage()}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={(e) => this.handleSendMessage()}>
                                            <Send />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}/>
                    </form>
                </Box>
            </React.Fragment>
        );
    }
}
export default Chatroom;